<template>
  <div id="modal" class="loading-modal" v-show="modalShown" @click="close">
    <div class="image">
      <img :src="image" />
    </div>
  </div>
</template>
<script>
export default {
  name: 'ImageViewer',
  components: {
  },
  props: {
    image: String
  },
  data () {
    return {
      modalShown: false
    }
  },
  watch: {
  },
  computed: {
  },
  methods: {
    /** モーダル表示 */
    showModal: function () {
      this.modalShown = true
    },
    close: function () {
      this.modalShown = false
    }
  }
}
</script>
<style src="../../../../css/dctop.scss" lang="scss" scoped></style>
<style lang="scss" scoped>
.loading-modal {
  z-index: 10000;
  background-color: rgba(0, 0, 0, 0.2);
  width: 100%;
  height: 100%;
  position: fixed;
}
// .image {
//     background: #FFFFFF;
//     max-width: calc(650px / 1.5);
//     // max-height: calc(880px / 1.5);
//     // width: 100%;
//     // height: 100%;
//     margin: 5% auto;
//     img {
//       width: 100%;
//       height: 100%;
//     }
// }
.image {
    // max-width: calc(650px / 1.5);
    // max-height: calc(880px / 1.5);
    max-width: 800px;
    margin: 5% auto;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    img {
      width: 100%;
      height: 100%;
    }
}
.image-fit {
    background: initial;
    max-width: fit-content;
    max-height: fit-content;
    // width: 100%;
    // height: 100%;
    margin: 5% auto;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}
</style>



// WEBPACK FOOTER //
// src/main/js/hakotan/components/top/product/common/ImageViewer.vue